import { TermForm } from "components";

export default function Term() {
	return (
		<div className="tenant-page">
			<TermForm />
		</div>
	);
}
